/** Setor GEP dos pedidos */
export interface PedidoSetorGep {
    id: number;
    nome: string;
}

export const setorGepRepresentante: PedidoSetorGep = {id: 1, nome: 'Representante'};
export const setorGepFinanceiro: PedidoSetorGep = {id: 2, nome: 'Financeiro'};
// export const setorGepAprovado: PedidoSetorGep = {id: 3, nome: 'Aprovado'};
// export const setorGepReprovado: PedidoSetorGep = {id: 4, nome: 'Reprovado'};
export const setorGepCancelado: PedidoSetorGep = {id: 5, nome: 'Cancelado'};
export const setorGepExpedicao: PedidoSetorGep = {id: 6, nome: 'Expedição'};
export const setorGepExpedicaoASeparar: PedidoSetorGep = {id: 61, nome: 'A Separar'}; // Etapa de "A Separar" do GEP da Expedição
export const setorGepExpedicaoEmSeparacao: PedidoSetorGep = {id: 62, nome: 'Em Separacao'}; // Etapa de "Em Separação" do GEP da Expedição
export const setorGepFaturamento: PedidoSetorGep = {id: 7, nome: 'Faturamento'};
export const setorGepColeta: PedidoSetorGep = {id: 8, nome: 'Coleta'};
export const setorGepTransportadora: PedidoSetorGep = {id: 9, nome: 'Transportadora'};
export const setorGepEntregue: PedidoSetorGep = {id: 10, nome: 'Entregue'};
export const setorGepComercial: PedidoSetorGep = {id: 11, nome: 'Comercial'};
export const setorGepAguardandoProducao: PedidoSetorGep = {id: 12, nome: 'Aguardando Produção'};
export const setorGepPCP: PedidoSetorGep = {id: 13, nome: 'PCP'};

export const pedidoSetoresGep: PedidoSetorGep[] = [
    setorGepRepresentante,
    setorGepFinanceiro,
    // setorGepAprovado,
    // setorGepReprovado,
    setorGepComercial,
    setorGepPCP,
    setorGepCancelado,
    setorGepAguardandoProducao,
    setorGepExpedicao,
    setorGepFaturamento,
    setorGepColeta,
    setorGepTransportadora,
    setorGepEntregue,
];

/** Verifica se o setor GEP do pedido é igual a Representante */
export function isPedidoSetorGepRepresentante(setorGep: number): boolean {
    return setorGep === setorGepRepresentante.id;
}

/** Verifica se o setor GEP do pedido é igual a Financeiro */
export function isPedidoSetorGepFinanceiro(setorGep: number): boolean {
    return setorGep === setorGepFinanceiro.id;
}

/** Verifica se o setor GEP do pedido é igual a Cancelado */
export function isPedidoSetorGepCancelado(setorGep: number): boolean {
    return setorGep === setorGepCancelado.id;
}

/** Verifica se o setor GEP do pedido é igual a Expedição */
export function isPedidoSetorGepExpedicao(setorGep: number): boolean {
    return setorGep === setorGepExpedicao.id;
}

/** Verifica se o setor GEP do pedido é igual a Expedição A Separar */
export function isPedidoSetorGepExpedicaoASeparar(setorGep: number, dataInicioExpedicao: Date): boolean {
    return isPedidoSetorGepExpedicao(setorGep) && !dataInicioExpedicao;
}

/** Verifica se o setor GEP do pedido é igual a Expedição Em Separação */
export function isPedidoSetorGepExpedicaoEmSeparacao(setorGep: number, dataInicioExpedicao: Date, dataTerminoExpedicao: Date): boolean {
    return isPedidoSetorGepExpedicao(setorGep) && dataInicioExpedicao && !dataTerminoExpedicao;
}

/** Verifica se o setor GEP do pedido é igual a Faturamento */
export function isPedidoSetorGepFaturamento(setorGep: number): boolean {
    return setorGep === setorGepFaturamento.id;
}

/** Verifica se o setor GEP do pedido é igual a Coleta */
export function isPedidoSetorGepColeta(setorGep: number): boolean {
    return setorGep === setorGepColeta.id;
}

/** Verifica se o setor GEP do pedido é igual a Transportadora */
export function isPedidoSetorGepTransportadora(setorGep: number): boolean {
    return setorGep === setorGepTransportadora.id;
}

/** Verifica se o setor GEP do pedido é igual a Entregue */
export function isPedidoSetorGepEntregue(setorGep: number): boolean {
    return setorGep === setorGepEntregue.id;
}

/** Verifica se o setor GEP do pedido é igual a Comercial */
export function isPedidoSetorGepComercial(setorGep: number): boolean {
    return setorGep === setorGepComercial.id;
}

/** Verifica se o setor GEP do pedido é igual a Aguardando Produção */
export function isPedidoSetorGepAguardandoProducao(setorGep: number): boolean {
    return setorGep === setorGepAguardandoProducao.id;
}

/** Verifica se o setor GEP do pedido é igual a PCP */
export function isPedidoSetorGepPCP(setorGep: number): boolean {
    return setorGep === setorGepPCP.id;
}
